import type { GalleryPreset } from "../types";

export const earlyCareerPhdPresets: GalleryPreset[] = [
  {
    presetId: "phd-candidate-dossier",
    presetVersion: 1,
    name: "PhD Candidate Dossier",
    tagline: "Dynamic modular presence highlighting dissertation, talks, and skills",
    category: "early-career-phd",
    filters: {
      purpose: "academic-cv",
      aesthetic: "modern",
      contentEmphasis: ["publications", "skills", "projects"],
      userStage: "phd-candidate",
    },
    intendedAudience: "Ph.D. candidates preparing for dissertation defense and job market",
    requiredTier: "starter",
    thumbnailUrl: "/thumbnails/phd-candidate-dossier.webp",
    structureId: "bento-grid",
    themeId: "theme-aurora-vibrant",
    blueprintId: "blueprint-early-career",
    demoDataId: "persona-alex-rivera",
    isFeatured: true,
  },
  {
    presetId: "postdoctoral-fellow",
    presetVersion: 1,
    name: "Postdoctoral Fellow",
    tagline: "Authoritative CV-ready portfolio designed for academic faculty applications",
    category: "early-career-phd",
    filters: {
      purpose: "academic-cv",
      aesthetic: "formal",
      contentEmphasis: ["publications", "experience"],
      userStage: "postdoc",
    },
    intendedAudience: "Postdoctoral researchers and research fellows on the job market",
    requiredTier: "starter",
    thumbnailUrl: "/thumbnails/postdoctoral-fellow.webp",
    structureId: "faculty-linear",
    themeId: "theme-oxford-navy",
    blueprintId: "blueprint-early-career",
    demoDataId: "persona-dr-sharma",
  },
  {
    presetId: "monochrome-minimal",
    presetVersion: 1,
    name: "Monochrome Minimal",
    tagline: "High-contrast Swiss typographic presentation with zero distractions",
    category: "early-career-phd",
    filters: {
      purpose: "academic-cv",
      aesthetic: "minimal",
      contentEmphasis: ["publications", "experience"],
      userStage: "phd-candidate",
    },
    intendedAudience: "Graduate students and early scholars wanting an ultra-clean site",
    requiredTier: "starter",
    thumbnailUrl: "/thumbnails/monochrome-minimal.webp",
    structureId: "faculty-linear",
    themeId: "theme-swiss-monochrome",
    blueprintId: "blueprint-early-career",
    demoDataId: "persona-alex-rivera",
  },
  {
    presetId: "conference-speaker",
    presetVersion: 1,
    name: "Conference Speaker",
    tagline: "Showcase layout emphasizing keynote slides, invited talks, and tutorials",
    category: "early-career-phd",
    filters: {
      purpose: "research-showcase",
      aesthetic: "dark",
      contentEmphasis: ["projects", "experience"],
      userStage: "postdoc",
    },
    intendedAudience: "Invited speakers, workshop organizers, and early-career researchers",
    requiredTier: "pro",
    thumbnailUrl: "/thumbnails/conference-speaker.webp",
    structureId: "showcase-portfolio",
    themeId: "theme-obsidian-executive",
    blueprintId: "blueprint-early-career",
    demoDataId: "persona-dr-sharma",
  },
  {
    presetId: "fellowship-applicant",
    presetVersion: 1,
    name: "Fellowship Applicant",
    tagline: "Classic editorial proposal dossier tailored for grant and fellowship review",
    category: "early-career-phd",
    filters: {
      purpose: "academic-cv",
      aesthetic: "editorial",
      contentEmphasis: ["publications", "experience", "grants"],
      userStage: "postdoc",
    },
    intendedAudience: "Scholars applying for prestigious fellowships and early-career grants",
    requiredTier: "starter",
    thumbnailUrl: "/thumbnails/fellowship-applicant.webp",
    structureId: "editorial-split",
    themeId: "theme-academic-royal",
    blueprintId: "blueprint-early-career",
    demoDataId: "persona-dr-sharma",
  },
];
